module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pl-dialog', {
    attrs: {
      "title": 'Switch Moderators?',
      "size": 'sm'
    },
    on: {
      "close": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_c('div', {
    staticClass: "flex flex-col flex-grow mx-auto p-7 justify-center"
  }, [_c('div', {
    staticClass: "flex flex-row items-center"
  }, [_c('div', {
    staticClass: "mr-3 text-base w-12 text-right"
  }, [_vm._v("From:")]), _vm._v(" "), _c('img', {
    staticClass: "mr-3 rounded-full w-8 h-8",
    attrs: {
      "src": _vm.user_moderator.user.avatar_url,
      "alt": "avatar"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "font-semibold text-2xl"
  }, [_vm._v(_vm._s(_vm.user_moderator.user.name))])]), _vm._v(" "), _c('div', {
    staticClass: "flex flex-row items-center pt-7"
  }, [_c('div', {
    staticClass: "mr-3 text-base w-12 text-right"
  }, [_vm._v("To:")]), _vm._v(" "), _c('img', {
    staticClass: "mr-3 rounded-full w-8 h-8",
    attrs: {
      "src": _vm.participation.user.avatar_url,
      "alt": "avatar"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "font-semibold text-2xl"
  }, [_vm._v(_vm._s(_vm.participation.user.name))])])]), _vm._v(" "), _c('div', {
    staticClass: "flex flex-row items-center justify-center p-7"
  }, [_c('button', {
    staticClass: "mr-2.5 px-8 py-2 hover:bg-gray-100 rounded cursor-pointer text-gray-400 :hover:text-gray-500 font-semibold",
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_vm._v("\n      NO\n    ")]), _vm._v(" "), _c('button', {
    staticClass: "px-8 py-2 bg-primary rounded cursor-pointer text-white font-semibold",
    on: {
      "click": _vm.switchModerator
    }
  }, [_vm._v("\n      YES\n    ")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-182f2046!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/features/liveDiscussion/components/modals/moderatorModal.vue
// module id = 1822
// module chunks = 61